














import { Vue, Component, Prop } from "vue-property-decorator";

import TextFieldPlaceholder from "./TextFieldPlaceholder.vue";

@Component({
    components: { TextFieldPlaceholder }
})
export default class VideoPlaceholder extends Vue {
    @Prop({ default: '' }) modificationName: string;
    @Prop({ required: true }) text: string;
}
